import './style.css';
import { ReactComponent as BackIcon } from "../../../../assets/svg/icons/back.svg";
import { useFilter } from '../../../../hooks/useFilter';
import { ShowData } from '..';
import { useEffect } from "react";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { IOptionsSystemManagerLinks } from '../../../../contexts/FilterContext';

const systemManagerSections: {
    title: string;
    items: { label: string; value: NonNullable<IOptionsSystemManagerLinks> }[];
}[] = [
        {
            title: "Cadastros",
            items: [
                { label: "Propriedades e Áreas", value: "PROPERTIES_AREAS" },
                { label: "Perfis", value: "PROFILES_USERS" }
            ],
        },
        {
            title: "Monitoramentos",
            items: [
                { label: "Monitoramento de tarefas", value: "TASK_EVALUATION" },
                { label: "Avaliação de pastagem", value: "PASTURE_EVALUATION" },
            ],
        },
        {
            title: "Animais",
            items: [
                { label: "Lotes", value: "CREATE_BATCH" },
                { label: "Manejo de Pasto", value: "PASTURE_MANAGEMENT" },
                { label: "Categorias e pesos", value: "CATTLE_MAP" },
            ],
        },
        {
            title: "Suplementação",
            items: [
                { label: "Salgadores", value: "SALTERS" },
                { label: "Produtos", value: "PRODUCTS" },
                { label: "Estoque", value: "STOCK" },
            ],
        },
    ];

export function SystemManager() {
    const { systemManager, sideBarOptionSelected, setSystemManager, setRangeDays, setViewRangeDays, onBoardingDate } = useFilter();
    const { optionForm, setOptionForm } = useEditOnboarding();

    useEffect(() => {
        const lastMounth = new Date();
        lastMounth.setMonth(lastMounth.getMonth() - 1);
        const newRangeDays = { from: lastMounth, to: new Date() }
        setRangeDays(newRangeDays);
        setViewRangeDays(newRangeDays);
    }, []);

    useEffect(() => {
        if (systemManager !== "TASK_EVALUATION") return;

        const today = new Date();
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        const defaultRange = { from: thirtyDaysAgo, to: today };

        setRangeDays(defaultRange);
        setViewRangeDays(defaultRange);
    }, [setRangeDays, setViewRangeDays, systemManager]);

    useEffect(() => {
        if (
            systemManager !== "PASTURE_EVALUATION" ||
            !onBoardingDate ||
            Number.isNaN(onBoardingDate.getTime())
        ) {
            return;
        }

        const defaultRange = {
            from: new Date(onBoardingDate),
            to: new Date(),
        };

        setRangeDays(defaultRange);
        setViewRangeDays(defaultRange);
    }, [onBoardingDate, setRangeDays, setViewRangeDays, systemManager]);

    useEffect(() => {
        const openingEvaluatorForm =
            systemManager === "MANAGER_EVALUATORS" &&
            optionForm === "create-evaluator";
        if (!openingEvaluatorForm) setOptionForm(undefined)
    }, [setOptionForm, systemManager]);

    return (
        sideBarOptionSelected == "MANAGER_SYSTEM" && systemManager === null
            ?
            <div className="templateDataManager">
                <h2 style={{ marginBottom: 10 }}>Gerenciar sistema</h2>
                <div className="delimiter" style={{ marginBottom: 20 }} />
                <div className="templateDataManager__container">
                    {systemManagerSections.map((section) => (
                        <div className="templateDataManager__container--item" key={section.title}>
                            <h2>{section.title}</h2>
                            {section.items.map((item) => (
                                <button
                                    className="templateDataManager__container--container"
                                    key={item.value}
                                    onClick={() => setSystemManager(item.value)}
                                >
                                    <span>{item.label}</span>
                                    <BackIcon className='icon' />
                                </button>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            :
            <ShowData />
    );
};
